import React, { FC, ReactNode, useState } from 'react'
import s from './Accordion.module.sass'
import IconArrow from '@icons/icon-arrow-small.svg'
import { Text } from '@shared/ui/Typography/Text'

interface Props {
  title: string
  children?: ReactNode
  className?: string
}

const Accordion: FC<Props> = ({ title, children, className }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className={`${s.accordion} ${className || ''}`} onClick={() => setIsOpen(!isOpen)}>
      <Text sizes='ML' className={s.header}>
        {title} <IconArrow className={`${s.chevron} ${isOpen ? s.flip : ''}`} />
      </Text>

      {isOpen && (
        <div onClick={(e) => e.stopPropagation()} className={s.content}>
          {children}
        </div>
      )}
    </div>
  )
}

export default Accordion
